import { Controller } from "@hotwired/stimulus"

// Local "Assigned to me" / "Raised by me" toggle for the ticket icon's My
// Support Cards popover (#2427). Deliberately not persist-tabs: that
// controller restores active-tab state from a page-wide `?tab=` URL param,
// and this header partial renders on every page -- a page already using
// `?tab=` for its own tabs could collide with this popover's tab state.
// This controller is scoped entirely to the popover with no URL or
// localStorage persistence -- the popover is transient and resets to
// "Assigned to me" each time the page (re)loads, which is expected.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: { type: String, default: "assigned" } }

  connect() {
    this._show(this.activeValue)
  }

  switch(event) {
    // Stop propagation -- the popover wrapper listens for
    // click->dropdown#toggle on itself, so an unstopped click here bubbles
    // up and closes the whole popover instead of just switching tabs (#2427).
    event.stopPropagation()

    const tab = event.currentTarget.dataset.tab
    if (!tab || tab === this.activeValue) return

    this.activeValue = tab
    this._show(tab)
  }

  // -- private --

  _show(activeTab) {
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== activeTab)
    })

    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tab === activeTab
      tab.classList.toggle("border-sapphire", isActive)
      tab.classList.toggle("text-sapphire", isActive)
      tab.classList.toggle("border-transparent", !isActive)
      tab.classList.toggle("text-gray-500", !isActive)
    })
  }
}
